import { render, staticRenderFns } from "./CivilCases.vue?vue&type=template&id=92bfcf9a&"
import script from "./CivilCases.vue?vue&type=script&lang=js&"
export * from "./CivilCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports